<template>
  <div class="grade-inquiry">
    <div class="card">
      <div class="card-header">
        <span class="card-title">成绩查询</span>
      </div>
      <div class="flex menu-bar">
        <div class="flex gap12">
          <div style="flex-shrink: 0;">课程名称</div>
          <el-input v-model="searchData.trainingName" clearable placeholder="请输入课程名称"></el-input>
        </div>
        <div class="flex gap12">
          <div style="flex-shrink: 0;">培训方式</div>
          <el-select v-model="searchData.trainingType" clearable placeholder="请选择培训方式">
            <el-option label="面授" value="面授"></el-option>
            <el-option label="网络" value="网络"></el-option>
          </el-select>
        </div>
        <div class="flex gap12">
          <el-date-picker
            v-model="searchData.beginTime"
            type="datetime"
            placeholder="课程开始时间"
            format="yyyy-MM-dd HH:mm:ss"
            >
          </el-date-picker>
        </div>
        <div class="flex gap12">
          <el-date-picker
            v-model="searchData.endTime"
            type="datetime"
            placeholder="课程结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            >
          </el-date-picker>
        </div>
        <!-- <div class="flex gap12">
          <div style="flex-shrink: 0;">课程时间段</div>
          <el-select v-model="searchData.timePeriod" clearable placeholder="请选择时间段">
            <el-option label="上午" value="morning"></el-option>
            <el-option label="下午" value="afternoon"></el-option>
            <el-option label="全天" value="fullday"></el-option>
          </el-select>
        </div> -->
        <div class="flex button-group">
          <el-button size="mini" icon="el-icon-search" type="warning" @click="search">搜索</el-button>
          <el-button size="mini" icon="el-icon-search" @click="reset">重置</el-button>
          <el-button size="mini" type="warning" @click="printGrade">成绩打印</el-button>
          <el-button size="mini" type="warning" @click="viewStampTime">课程证明盖章申请</el-button>
        </div>
      </div>
      <div class="card-body">
        <el-table :data="gradeList" border :header-cell-style="{background: '#fff6e8',color: '#515a6e'}">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="trainingBatch" label="培训批次" align="center"></el-table-column>
          <el-table-column prop="trainingType" label="培训方式" align="center"></el-table-column>
          <el-table-column prop="trainingName" label="课程名称" align="center"></el-table-column>
          <el-table-column prop="beginTime" label="开课时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结课时间" align="center"></el-table-column>
          <el-table-column prop="classHours" label="课程学时" align="center">
            <template slot-scope="scope">
              {{ scope.row.classHours || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="acquiredClassHours" label="获得学时" align="center">
            <template slot-scope="scope">
              {{ scope.row.acquiredClassHours||'-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getProgress} from '@/api/course.js'
export default {
  data() {
    return {
      searchData: {
        trainingName: '',
        trainingType: '',
        beginTime: '',
        endTime: '',
        // timePeriod: ''
      },
      gradeList: [],
      currentPage: 1,
      total: 0
    }
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      getProgress(
        {
          page:this.currentPage,
          size:10,
          ...this.searchData
        }
      ).then(res=>{
        if(res.data.code==200){
          this.total=res.data.data.total
          this.gradeList=res.data.data.records.map(v=>{
            return{
              ...v,
              ...v.trainingListEntity
            }
          })
        }
      })
    },
    search() {
      this.currentPage=1
      this.getList()
    },
    reset() {
      this.searchData = {
         trainingName: '',
        trainingType: '',
        beginTime: '',
        endTime: '',
        // timePeriod: ''
      }
    },
    handleSizeChange(index) {
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.getList()
    },
    printGrade() {
      this.$message.success('成绩打印功能')
    },
    viewStampTime() {
      this.$message.success('课程证明盖章时间')
    }
  }
}
</script>

<style lang="less" scoped>
.menu-bar{
  font-size: 14px;
  color: #606266;
  gap:21px;
  flex-wrap: wrap;
}
.button-group {
  gap: 12px;
}
.gap12{
  gap:12px;
}
.grade-inquiry {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .card-body {
      margin-top: 16px;
    }
  }
}
.pages {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-pager li.active {
  color: #ED9D26;
}
</style>
